<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-users'></i> Cashback Special Member Rate List</h3>
              <div class="float-right">
                <b-button variant="primary" class="float-right" @click="showManagementModal" v-if="checkAccessPrivilege('JeetPrivilege.Cashback.SpecialMember.Assign')">Add Special Member</b-button>
              </div>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(sn)="data">
                {{data.index+1 + ((currentPage-1)*perPage)}}
              </template>
              <template v-slot:cell(SlotGame)="data">
                <span>{{format(data.item.SlotGame, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(LiveGame)="data">
                <span>{{format(data.item.LiveGame, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(OtherGame)="data">
                <span>{{format(data.item.OtherGame, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(Action)="data">
                <b-button variant="warning" @click="showUpdateSpecialMemberModal(data.item.MemberId, data.item.Username, data.item.SlotGame, data.item.LiveGame, data.item.OtherGame)" v-if="checkAccessPrivilege('JeetPrivilege.Cashback.SpecialMember.Update')">Update</b-button>
                <b-button variant="danger" @click="showRemoveSpecialMemberModal(data.item.MemberId)" v-if="checkAccessPrivilege('JeetPrivilege.Cashback.SpecialMember.Remove')">Remove</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="showManagementModal" size="lg" header-bg-variant="primary" hide-footer title="Assign Special Member Rate">
      <div class="d-block">
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="12">
                <b-form-group :state="!$v.searchName.$error">
                  <b-input-group>
                    <b-form-input type="text" placeholder="Enter Username for Search" v-model.trim="searchName" :state="$v.searchName.$error?false:null" @focus.native="$v.searchName.$touch"></b-form-input>
                    <b-input-group-button class="input-group-append">
                      <b-btn variant="success" @click="searchMember" :disabled="$v.searchName.$invalid">
                        <i class="fa fa-search"></i> Search
                      </b-btn>
                    </b-input-group-button>
                  </b-input-group>
                  <div v-if="$v.searchName.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.searchName.required">Username is required</div>
                    <div class="invalid-feedback d-block" v-else-if="!$v.searchName.minLength">Must have at least {{ $v.searchName.$params.minLength.min}} letters</div>
                    <div class="invalid-feedback d-block" v-else-if="!$v.searchName.maxLength">Must no exceed {{ $v.searchName.$params.maxLength.max}} letters</div>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="members" :fields="memberFields" :current-page="memberCurrentPage" :per-page="memberPerPage">
                  <template v-slot:cell(action)="data">
                    <b-button variant="success" @click="showAddSpecialMemberModal(data.item)">Add Cashback</b-button>
                  </template>
                </b-table>
                <nav>
                  <b-pagination :total-rows="getMemberRowCount(members)" :per-page="memberPerPage" v-model="memberCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-btn class="mt-3" variant="outline-danger" @click="hideManagementModal">Cancel</b-btn>
    </b-modal>

    <b-modal ref="showAddSpecialMemberModal" v-model="showAddSpecialMember" size="lg" header-bg-variant="primary" hide-footer @hide="hideAddSpecialMemberModal" title="Assign Speical Member Rate">
      <div class="d-block">
        <b-row>
          <b-col sm="12">
            <label for="cUsername">Username</label><br/>
            <b-form-input id="cUsername" type="text" v-model.trim="form.username" readonly></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.username.required">Username is required</div>
          </b-col>
          <br><br><br><br>
          <b-col sm="4">
            <label for="slotGame">Slot Game Rate</label><br/>
            <b-form-input id="slotGame" type="text" v-model.trim="form.slotGame"></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.slotGame.required">Slot Game Rate is required</div>
          </b-col>
          <b-col sm="4">
            <label for="liveGame">Live Game Rate</label><br/>
            <b-form-input id="liveGame" type="text" v-model.trim="form.liveGame"></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.liveGame.required">Live Game Rate is required</div>
          </b-col>
          <b-col sm="4">
            <label for="otherGame">Other Game Rate</label><br/>
            <b-form-input id="otherGame" type="text" v-model.trim="form.otherGame"></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.otherGame.required">Other Game Rate is required</div>
          </b-col>
          <br><br><br><br>
          <b-col sm="12">
            <b-button variant="success" @click="assignSpecialMember()">Assign</b-button>
            <b-button variant="danger" @click="hideAddSpecialMemberModal()">Cancel</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal ref="showUpdateSpecialMemberModal" v-model="showUpdateSpecialMember" size="lg" header-bg-variant="primary" hide-footer @hide="closeUpdateSpecialMemberModal" title="Update Speical Member Rate">
      <div class="d-block">
        <b-row>
          <b-col sm="12">
            <label for="cUsername">Username</label><br/>
            <b-form-input id="cUsername" type="text" v-model.trim="form.username" readonly></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.username.required">Username is required</div>
          </b-col>
          <br><br><br><br>
          <b-col sm="4">
            <label for="slotGame">Slot Game Rate</label><br/>
            <b-form-input id="slotGame" type="text" v-model.trim="form.slotGame"></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.slotGame.required">Slot Game Rate is required</div>
          </b-col>
          <b-col sm="4">
            <label for="liveGame">Live Game Rate</label><br/>
            <b-form-input id="liveGame" type="text" v-model.trim="form.liveGame"></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.liveGame.required">Live Game Rate is required</div>
          </b-col>
          <b-col sm="4">
            <label for="otherGame">Other Game Rate</label><br/>
            <b-form-input id="otherGame" type="text" v-model.trim="form.otherGame"></b-form-input>
            <div class="invalid-feedback d-block" v-if="!$v.form.otherGame.required">Other Game Rate is required</div>
          </b-col>
          <br><br><br><br>
          <b-col sm="12">
            <b-button variant="success" @click="assignSpecialMember()">Assign</b-button>
            <b-button variant="danger" @click="hideAddSpecialMemberModal()">Cancel</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../../events.js'
  import numeral from 'numeral'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')

  export default {
    name: 'whitelist-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        showAddSpecialMember: false,
        items: [],
        members: [],
        fields: [
          {key: 'MemberId', label: 'MemberId'},
          {key: 'Username', label: 'Username'},
          {key: 'SlotGame', label: 'Slot Game Rate'},
          {key: 'LiveGame', label: 'Live Game Rate'},
          {key: 'OtherGame', label: 'Other Game Rate'},
          {key: 'AddTime', label: 'Add Time'},
          {key: 'Action', label: 'Action'}
        ],
        memberFields: [
          {key: 'Id', label: 'ID'},
          {key: 'Username', label: 'Username'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        memberCurrentPage: 1,
        perPage: 30,
        memberPerPage: 10,
        totalMemberRows: 0,
        operator: '',
        searchName: '',
        form: {
          memberId: '',
          username: '',
          slotGame: '',
          liveGame: '',
          otherGame: ''
        }
      }
    },
    validations: {
      searchName: { required, minLength: minLength(5), maxLength: maxLength(20) },
      form: {
        username: { required },
        slotGame: { required },
        liveGame: { required },
        otherGame: { required }
      }
    },
    methods: {
      format (num, fmt) {
        return numeral(num).format(fmt)
      },
      getRowCount (items) {
        return items.length
      },
      getMemberRowCount (members) {
        return members.length
      },
      async getSpecialMemberList () {
        try {
          let result = await this.$http.get(this.API_ENDPOINT + '/jeetprivilege/cashback/special/getlist', { headers: { 'Content-Type': 'application/json' } })
          this.items = result.data.data
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      searchMember () {
        this.$http.post(this.API_ENDPOINT + '/member/search', {searchName: this.searchName}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.members = response.data.members
          this.totalMemberRows = response.data.members.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      showManagementModal () {
        this.$refs.showManagementModal.show()
      },
      hideManagementModal () {
        this.$refs.showManagementModal.hide()
      },
      showAddSpecialMemberModal (item) {
        this.form.memberId = item.Id
        this.form.username = item.Username
        this.showAddSpecialMember = true
      },
      hideAddSpecialMemberModal () {
        this.form.memberId = ''
        this.form.username = ''
        this.form.slotGame = ''
        this.form.liveGame = ''
        this.form.otherGame = ''
        this.showAddSpecialMember = false
        this.getSpecialMemberList()
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      },
      async assignSpecialMember () {
        try {
          let data = {
            memberId: this.form.memberId,
            username: this.form.username,
            slotGame: this.form.slotGame,
            liveGame: this.form.liveGame,
            otherGame: this.form.otherGame
          }
          this.$v.form.$touch()
          if (this.$v.form.$error) {
            return true
          } else {
            console.log(data)
            await this.$http.post(this.API_ENDPOINT + '/jeetprivilege/cashback/special/assign', data, { headers: { 'Content-Type': 'application/json' } })
            this.hideAddSpecialMemberModal()
          }
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      showUpdateSpecialMemberModal (memberId, username, slotGame, liveGame, otherGame) {
        this.form.memberId = memberId
        this.form.username = username
        this.form.slotGame = slotGame
        this.form.liveGame = liveGame
        this.form.otherGame = otherGame
        this.showUpdateSpecialMember = true
      },
      closeUpdateSpecialMemberModal () {
        this.form.memberId = ''
        this.form.username = ''
        this.form.slotGame = ''
        this.form.liveGame = ''
        this.form.otherGame = ''
        this.showUpdateSpecialMember = false
      }
    },
    created () {
      this.getSpecialMemberList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/specialMember/SpecialMemberTable.vue